import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Link2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export const RelocLinks = () => {
  const [d, setD] = useState(null);
  const [p, setP] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/relocation/link-pattern").then((r) => { setD(r.data); setP(r.data.pattern || r.data.suggested); }).catch(() => {}); }, []);
  if (!d) return null;
  const save = async (value) => {
    setBusy(true);
    try { const r = await api.put("/relocation/link-pattern", { pattern: value }); setD(r.data); setP(r.data.pattern || r.data.suggested); toast.success(value ? "Shop links saved for every guide" : "Shop links turned off"); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="border border-[#E2D9CC] bg-[#FAF7F2] p-7" data-testid="reloc-links">
      <p className="eyebrow mb-2 flex items-center gap-2"><Link2 className="w-4 h-4" strokeWidth={1.5} />Shop page links</p>
      <p className="text-sm text-[#1C181D] mb-4 max-w-3xl">The pattern for each guide's <b>Mobile App</b> and <b>Bundle</b> product pages on theexpatstudio.com. <code className="text-[#3B1B48]">{"{destination}"}</code> becomes e.g. <i>italy</i> or <i>italy-families</i>, and <code className="text-[#3B1B48]">{"{product}"}</code> becomes <i>app</i> or <i>bundle</i>. The links go into the store feed and the free app preview's buy buttons.</p>
      <div className="flex flex-col sm:flex-row gap-2 max-w-3xl">
        <Input data-testid="reloc-links-pattern" value={p} onChange={(e) => setP(e.target.value)} className="rounded-none bg-white font-mono text-xs" />
        <Button data-testid="reloc-links-save" onClick={() => save(p.trim())} disabled={busy} className="rounded-none">Save links</Button>
        {d.pattern && <Button data-testid="reloc-links-clear" variant="ghost" onClick={() => save("")} disabled={busy} className="rounded-none">Turn off</Button>}
      </div>
      <p className="text-xs mt-3 text-[#8C827A]" data-testid="reloc-links-state">{d.pattern ? "Active. Preview buy buttons go straight to each product page." : "Not saved yet. Until you save, preview buy buttons go to the theexpatstudio.com home page."}</p>
      {d.pattern && (
        <div className="mt-5 text-xs space-y-1.5 max-h-56 overflow-y-auto" data-testid="reloc-links-list">
          {d.guides.map((g) => (
            <div key={g.id} className="grid grid-cols-1 sm:grid-cols-[180px_1fr_1fr] gap-x-4 py-1.5 border-b border-[#E2D9CC]">
              <span className="text-[#1C181D]">{g.destination}{g.family ? " (families)" : ""}</span>
              <a href={g.links.toolkit} target="_blank" rel="noreferrer" className="text-[#3B1B48] break-all hover:underline" data-testid={`reloc-link-app-${g.id}`}>{g.links.toolkit}</a>
              <a href={g.links.bundle} target="_blank" rel="noreferrer" className="text-[#3B1B48] break-all hover:underline" data-testid={`reloc-link-bundle-${g.id}`}>{g.links.bundle}</a>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
